import {colorUtil} from "./color-util.js";
let drawNode = function (ctx) {
    ctx.Graph.nodeThreeObject(node => {
        // 实例化一个THREE.Object3D对象
        let groupObject = new THREE.Object3D();
        ctx.nodesChild = groupObject; // 为了获取它的父容器，以便后续控制父容器的显隐
        let isRootNode = node.id === ctx.rootId;
        let isRootNodeGroup = node.rootId === ctx.rootId;
        let isRootNodeTag = node.depth === '1' && node.rootId === ctx.rootId;
        let isPoiNode = node.depth === '0';
        let isMockNode = node.rootId === undefined;

        // 3D中插入2D文字
        if (isRootNode || isPoiNode) {
            const sprite = new SpriteText(node.name);
            sprite.color = 'rgba(255,255,255, 1)';
            sprite.textHeight = 18;
            sprite.material.transparent = true;
            sprite.material.depthWrite = false;
            sprite.position.set(10, isRootNode ? 54 : 42, 0);
            groupObject.add(sprite);

            // 3d文字
            // const textGeometry = new THREE.TextGeometry(node.id, {font: ctx.font, size: 20, height: 5, curveSegments: 12, bevelEnabled: false, bevelThickness: 10, bevelSize: 8, bevelSegments: 5,});
            // let textMesh = new THREE.Mesh(textGeometry, new THREE.MeshBasicMaterial( { color: 0xfefefe, overdraw: true } ));
            // groupObject.add(textMesh);
        }

        // 球的半径设置
        let radius = 100;
        if (isRootNode) {
            radius = 25;
        } else if (isPoiNode) {
            radius = 14;
        } else if (!isPoiNode && !isMockNode) {
            radius = 5;
        } else if (isRootNodeTag) {
            radius = 4;
        } else if (isRootNodeGroup) {
            radius = 4;
        } else {
            radius = 4;
        }

        let color = node[ctx.colorKey];
        isMockNode && (color = colorUtil.lightnessTo(color, .5));
        let sphereMesh = null;
        if (isRootNode || isPoiNode) {
            // let color = 0x107BA8;
            let color = colorUtil.colorStr2Hex(`#${ctx.theme.otherPoi}`) || 0x107BA8;
            if (isRootNode) {
                color = colorUtil.colorStr2Hex(`#${ctx.theme.rootPoi}`) || 0x44B3E3;
            }
            sphereMesh = new THREE.Mesh(
                new THREE.SphereGeometry(radius, 16, 16),
                new THREE.MeshPhongMaterial({
                    color: new THREE.Color(color),
                    map: ctx.nodeTexture,
                    bumpMap: ctx.nodeTexture,
                })
            );

            let customMaterial = new THREE.ShaderMaterial(
                {
                    uniforms: {
                        'c': { type: 'f', value: 0.0 },
                        'p': { type: 'f', value: 1.4 },
                        glowColor: { type: 'c', value: new THREE.Color(color) },
                        // glowColor: { type: 'c', value: new THREE.Color(window.$qsObj.poiColor ? colorUtil.colorStr2Hex(`#${window.$qsObj.poiColor}`) : colorUtil.colorStr2Hex('#52cbf8')) },
                    },
                    vertexShader: document.getElementById( 'vertexShader' ).textContent,
                    fragmentShader: document.getElementById( 'fragmentShader' ).textContent,
                    side: THREE.DoubleSide,
                    // side: THREE.BackSide,
                    blending: THREE.AdditiveBlending,
                    transparent: false,
                    depthTest: true,
                    depthWrite: false,
                    polygonOffset: true,
                    polygonOffsetFactor: -1
                });
            let moonGlow = new THREE.Mesh( new THREE.SphereGeometry(radius, 32, 32), customMaterial );
            moonGlow.position.copy(sphereMesh.position);
            moonGlow.scale.multiplyScalar(1.8);
            groupObject.add(moonGlow);
            if (isRootNode) {
                let rootMoon = moonGlow;
                let grow = {
                    p: 1,
                };
                ctx.moonTweenA = new TWEEN.Tween(grow).to({
                    p: [4, 1]
                }, 1500)
                    .repeat(Infinity)
                    .onUpdate(() => {
                        rootMoon.material.uniforms.p.value = grow.p;
                    })
                    .start();
            }
        } else {
            sphereMesh = new THREE.Mesh(
                new THREE.SphereGeometry(radius, 16, 16),
                new THREE.MeshPhongMaterial({
                    color: colorUtil.colorStr2Hex(`#${ctx.theme.mainColor}`) || new THREE.Color(0x00b0f2),
                    // color: window.$qsObj.color ? colorUtil.colorStr2Hex(`#${window.$qsObj.color}`) : new THREE.Color(0x00b0f2),
                    // map: ctx.nodeTexture,
                    // envMap: ctx.nodeTexture,
                    // specular: new THREE.Color(0x00b0f2),
                    // bumpMap: ctx.nodeTexture,
                    // shininess: 60,
                    // shading: THREE.FlatShading,
                    transparent: false,
                    opacity: 1,
                })
            );
        }
        groupObject.add(sphereMesh); // 在对象里面添加第一个子元素
        ctx.nodesParent = groupObject.parent;
        return groupObject;
    });
};

export default drawNode;
